import { Comparison } from '@/types/comparison.types';
import drivesourceComparisons from './comparisons.drivesource.json';
import homesourceComparisons from './comparisons.homesource.json';

export const getComparisons = (): Comparison[] => {
    const displayName = import.meta.env.VITE_ASSISTANT_DISPLAY_NAME;
    switch (displayName) {
        case 'DriveSource':
            return drivesourceComparisons as Comparison[];
        case 'HomeSource':
            return homesourceComparisons as Comparison[];
        default:
            return [];
    }
};

export const getComparisonBySlug = (slug: string): Comparison | undefined => {
    return getComparisons().find(c => c.slug === slug);
};

export const getComparisonsByGroup = (): Record<string, Comparison[]> => {
    const comparisons = getComparisons();
    return comparisons.reduce((acc, c) => {
        if (!acc[c.categoryGroup]) acc[c.categoryGroup] = [];
        acc[c.categoryGroup].push(c);
        return acc;
    }, {} as Record<string, Comparison[]>);
};
